<div class="d-flex" [ngClass]="aligment">
  <img [appStoryblok]="_editable"  [ngClass]="{'clickable withOpacity':url?.url}" [src]="image"  (click)="gotoUrl()" [ngStyle]="{'max-height': height + 'px'}" [alt]="alt_text">
</div>
